'use client';

/* eslint-disable @typescript-eslint/no-explicit-any */
import { c as _c } from "react/compiler-runtime";
import Total from '@/streambot/Total';
import { Widgets } from '@/streambot/Widgets';
import { StreambotWidgetWrapper, useGetWidgetComponentProps } from '@/streambotWidgetsPage/_dependencies/StreambotPageContent';
function StreambotTotalPageContent(t0) {
  const $ = _c(9);
  const {
    fundraisingEventId,
    preview,
    subtractCents
  } = t0;
  const {
    showPreview,
    props
  } = useGetWidgetComponentProps(Widgets.Total, fundraisingEventId, preview);
  const t1 = props as any;
  let t2;
  if ($[0] !== fundraisingEventId || $[1] !== showPreview || $[2] !== subtractCents || $[3] !== t1) {
    t2 = <Total {...t1} fundraisingEventId={fundraisingEventId} withDemoData={showPreview} subtractCents={subtractCents} />;
    $[0] = fundraisingEventId;
    $[1] = showPreview;
    $[2] = subtractCents;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== fundraisingEventId || $[6] !== showPreview || $[7] !== t2) {
    t3 = <StreambotWidgetWrapper fundraisingEventId={fundraisingEventId} preview={showPreview}>{t2}</StreambotWidgetWrapper>;
    $[5] = fundraisingEventId;
    $[6] = showPreview;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export default StreambotTotalPageContent;